import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { bindActionCreators, Dispatch } from "redux";

import { DateLiteral } from "@plex/culture-react";
import { DataTableDef } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues, useLocalizer, useLocalizerWithFallback } from "ui/hooks";
import { releaseMessages } from "ui/screens/release/release.localization";

import { IReleaseRow, IReleasesManagerState } from "../ReleasesManager.state";

interface IReleasesManagerGridProps {
  isSearched: boolean;
  gridData: IReleaseRow[];
}

const ReleasesManagerGrid: React.FC<IReleasesManagerGridProps> = ({ isSearched, gridData }) => {
  const localize = useLocalizer();
  const safeLocalize = useLocalizerWithFallback();

  const localizedValues = useLocalizedValues(() => {
    return {
      refineSearch: commonMessages.info("refineSearch"),
      startSearch: commonMessages.info("startSearch"),
      releaseId: releaseMessages.property("releaseId"),
      releaseName: releaseMessages.property("releaseName"),
      status: releaseMessages.property("status"),
      releaseDate: releaseMessages.property("releaseDate"),
      createdDate: releaseMessages.property("createdDate")
    };
  });

  return (
    <DataTableDef<IReleaseRow> data={gridData} keySelector={row => row.releaseId} emptyText={isSearched ? localizedValues.refineSearch : localizedValues.startSearch}>
      <DataTableDef.Column<IReleaseRow> id="releaseId" title={localizedValues.releaseId} sortable valueSelector={row => row.releaseId}>
        {row => <Link to={`/releases/${row.releaseId}/details`}>{row.releaseId}</Link>}
      </DataTableDef.Column>
      <DataTableDef.Column<IReleaseRow> id="name" title={localizedValues.releaseName} sortable valueSelector={row => localize(row.name.messageId)}>
        {row => safeLocalize(row.name.messageId, row.name.text)}
      </DataTableDef.Column>
      <DataTableDef.Column<IReleaseRow> id="status" title={localizedValues.status} sortable valueSelector={row => localize(row.status)}>
        {row => localize(row.status)}
      </DataTableDef.Column>
      <DataTableDef.Column<IReleaseRow> id="createdDate" title={localizedValues.createdDate} sortable valueSelector={row => row.createdDate}>
        {row => <DateLiteral value={new Date(row.createdDate)} options={{ datetime: "medium" }} />}
      </DataTableDef.Column>
      <DataTableDef.Column<IReleaseRow> id="releaseDate" title={localizedValues.releaseDate} sortable valueSelector={row => row.releaseDate}>
        {row => row.releaseDate && <DateLiteral value={new Date(row.releaseDate)} options={{ datetime: "medium" }} />}
      </DataTableDef.Column>
    </DataTableDef>
  );
};

export default connect(
  (state: { releasesManager: IReleasesManagerState }) => {
    const grid = state.releasesManager.grid;
    return {
      isSearched: grid.isSearched,
      gridData: grid.gridData
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators({}, dispatch);
  }
)(ReleasesManagerGrid);
